// extracted by mini-css-extract-plugin
export default {"subheader_wrapper":"style_subheader_wrapper__CoRYf","criterias_line":"style_criterias_line__TF56u"};